import React, { ReactElement } from 'react';

const ControlWrapper = (props): ReactElement => (
  <div className="control">{props.children}</div>
);

export default ControlWrapper;
